import dayjs from 'dayjs';
import React, { memo, useCallback, useEffect } from 'react';
import { useAliveController } from 'react-activation';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { setMessageVisible } from '../../../actions/layout';
import { logging, logPostInfo } from '../../../actions/log';
import { resetMessageList, setMessageZan } from '../../../actions/message';
import { CONTEXT, MICROCONTEXT } from '../../../config';
// import avatarV from '../../../static/f_user_v.png';
import UserHeader from '../../../static/message_sys.svg';
import styles from './SysLine.module.less';
// import getChildrenJSON from '../../../components/Comment/getChildrenJSON';
// import getHtmlByNodeList from '../../../components/Comment/getHtmlByNodeList';

const actionMap = {
  // 这个要看下面type类型的
  1: '点赞',
  2: '收藏',
  3: '评论',

  // 这个动作是评论相关的
  4: '点赞',
  5: '回复',
  // v8.0
  // 21: '未通过审核',
  // 24:
};
const typeMap = {
  1: '应用',
  2: '专题',
  3: '帖子',
  4: '评论', // 方便前端显示
  5: '评论', // 方便前端显示
};

const identity = {
  23: '用户成就消息 ',
  24: '用户身份变更消息',
};

const identity2 = {
  21: '评论审核不通过',
  22: '用户被@消息',
};

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ message = {}, setCommentIndexCallback, orderIndex, commentIndex }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { dropScope } = useAliveController();

  const handleComment = useCallback(() => {
    if (commentIndex !== orderIndex) {
      // 打开
      // eslint-disable-next-line no-unused-expressions
      setCommentIndexCallback && setCommentIndexCallback(orderIndex);
    } else {
      // 关闭
      // eslint-disable-next-line no-unused-expressions
      setCommentIndexCallback && setCommentIndexCallback(-1);
    }
  }, [commentIndex, orderIndex, setCommentIndexCallback]);

  const handleSkip = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Message_Sys',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: message.bizId,
          type: message.type,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    dispatch(setMessageVisible(false));
    dispatch(resetMessageList());
    switch (message.type) {
      case '1':
        history.push(
          message.androidType === '1'
            ? `${CONTEXT}/adetail/${message.bizId || ''}/-1/${message.bizInfo || '{}'}`
            : `${CONTEXT}/detail/soft/${message.bizId || ''}/${message.bizInfo || '{}'}`,
        );
        break;
      case '2':
        if (history?.pathname?.indexOf(`${CONTEXT}/special`) < 0) {
          dropScope('special');
        }
        const timer = setTimeout(() => {
          history.push(`${CONTEXT}/special?ztId=${message.bizId}`);
          clearTimeout(timer);
        }, 50);

        break;
      case '3':
        history.push(
          `${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${message.bizId}&source=msg`,
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className={styles.messageLine}>
        <div className={styles.user_avatar_box}>
          <img src={message.userHead || UserHeader} alt="" className={styles.user_image} />
        </div>
        <div
          className={`${styles.message_info} ${
            ['23', '24'].indexOf(message.optType) > -1 ? styles.message_info_center : ''
          }`}
        >
          <div className={`${styles.message_action}`}>
            <div
              className={`${styles.message_info} ${
                ['23', '24'].indexOf(message.optType) > -1 ? styles.message_info_center : ''
              }`}
            >
              {message.optType === '21' && '您发布的评论未通过审核'}
              {message.optType === '22' && (
                <>
                  <div className={styles.message_user}>
                    {message.userNickname || '商店用户'} &nbsp;
                  </div>
                  在评论中提到了你
                </>
              )}
              {message.optType === '23' && (
                <>
                  太棒了！你获得了&apos;{message?.achievement?.name}&apos;
                  {message?.achievement?.level}勋章
                </>
              )}
              {message.optType === '24' && <>你好！你的账号通过了 {message?.identity?.title}认证</>}
            </div>
            <div className={styles.message_action_time}>
              {message.createTime ? dayjs(message.createTime).format('YYYY-MM-DD HH:mm') : ''}
            </div>
          </div>
          {message.content && (
            <div className={styles.message_content} onClick={handleSkip}>
              {message.content && (
                <div className={styles.message_content_comment}>
                  <div className={styles.message_content_comment_detail}>
                    {message.optType === '21' && ' 我：'}
                    {message.optType === '22' && `${message?.userNickname}：`}
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          message.commentId !== message.originalCommentId &&
                          message.content.indexOf('@') === 0
                            ? message.content.split(':')[1]
                            : message.content,
                      }}
                    />
                  </div>
                </div>
              )}
              <div className={styles.message_content_title}>
                <div className={styles.message_content_title_type}>{typeMap[message.type]}</div>
                <div className={styles.message_content_title_content}>{message.bizName}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
});
